<template>
  <div v-if="invoice" class="row justify-content-center">
    <div class="col-12 col-xl-3">
      <DocumentSettings :title="invoice.number">
        <div slot="body">
          <div style="columns: 150px 3">
            <fg-input :label="$t('message.invoiceTo')">
              <div class="d-inline-block w-100">
                <router-link tag="a" :to="`/customers/view/${invoice.to._id}`">
                  {{ invoice.to.companyName }}
                </router-link>
              </div>
            </fg-input>
            <fg-input :label="$t('message.dateSent')">
              <div class="d-inline-block w-100">
                {{ invoice.sentDate | dateToHuman }}
              </div>
            </fg-input>
            <fg-input :label="$t('message.dateDue')">
              <div class="d-inline-block w-100">
                {{ invoice.dueDate | dateToHuman }}
              </div>
            </fg-input>
          </div>
          <hr />
          <fg-input :label="$t('message.status')">
            <div class="d-inline-block w-100">
              <span :class="statusClass">{{ status }}</span>
            </div>
          </fg-input>
          <hr />
          <n-button round simple @click.native.prevent="goBack('/invoices')">{{
            $t("message.goBack")
          }}</n-button>
        </div>
      </DocumentSettings>
    </div>
    <div class="col-12 col-xl-9">
      <document
        :title="$t('message.invoice')"
        :header-items="headerItems"
        :from-label="$t('message.invoiceFrom')"
        :from="invoice.from"
        :to-label="$t('message.invoiceRecipient')"
        :to="invoice.to"
        :sub-total="invoice.subTotal.displayValue"
        :vat-total="invoice.vatTotal.displayValue"
        :total="invoice.total.displayValue"
      >
        <template slot="table">
          <b-table
            :fields="tableFields"
            :items="invoice.items"
            stacked="md"
          ></b-table>
        </template>
      </document>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import {
  dateToHuman,
  dateToHumanWithTime,
  formatMoney
} from "@/helpers/helpers.js";
import InvoiceForm from "./InvoiceForm";
import { goBack } from "@/mixins";
import { Document, DocumentSettings } from "@/components";

export default {
  mixins: [goBack],
  components: {
    InvoiceForm,
    Document,
    DocumentSettings
  },
  data() {
    return {
      tableFields: [
        {
          key: "description",
          label: this.$t("message.invoiceItem")
        },
        {
          key: "description",
          label: this.$t("message.invoiceItem"),
          class: "document__table__description"
        },
        {
          key: "price",
          label: this.$t("message.invoiceItemUnitCost"),
          class: "document__table__price"
        },
        {
          key: "quantity",
          label: this.$t("message.invoiceItemQuantity"),
          class: "document__table__quantity"
        },
        {
          key: "vat",
          label: this.$t("message.invoiceItemVat"),
          class: "document__table__vat"
        },
        {
          key: "total",
          label: this.$t("message.invoiceItemPrice"),
          class: "document__table__total",
          formatter: (value, key, item) =>
            formatMoney(item.price * item.quantity)
        }
      ]
    };
  },
  methods: mapActions(["fetchInvoice"]),
  computed: {
    ...mapGetters(["invoice"]),
    headerItems() {
      return [
        {
          label: this.$t("message.invoiceNumber"),
          value: this.invoice.number
        },
        {
          label: this.$t("message.dateSent"),
          value: dateToHuman(this.invoice.sentDate)
        },
        {
          label: this.$t("message.dateDue"),
          value: dateToHuman(this.invoice.dueDate)
        }
      ];
    },
    statusClass() {
      if (!this.invoice) return;

      const { status, dueDate } = this.invoice;

      if (status === "PAID") return "badge badge-success";
      if (status === "CANCELLED") return "badge badge-warning";

      const today = moment();
      const due = moment(dueDate);

      const diff = due.diff(today);

      // Late
      if (diff < 0) return "badge badge-danger";

      // Open
      return "badge badge-info";
    },
    status() {
      if (!this.invoice) return;

      const { status, dueDate } = this.invoice;

      if (status === "PAID") return "Paid";
      if (status === "CANCELLED") return "Uncollectable";

      const today = moment();
      const due = moment(dueDate);

      const diff = due.diff(today);

      if (diff < 0) return "Late";

      return "Open";
    }
  },
  async created() {
    try {
      await this.fetchInvoice(this.$route.params.id);
    } catch (error) {
      this.$router.push("/invoices");
      this.$notify({
        type: "danger",
        title: this.$t("message.error"),
        text: this.$t("message.viewInvoiceFailure")
      });
    }
  },
  filters: {
    dateToHuman,
    dateToHumanWithTime
  }
};
</script>
